import CartAccountContinuePageV2 from './CartAccountContinuePageV2'

export default CartAccountContinuePageV2
// eslint-disable-next-line import/export
export * from './CartAccountContinuePageV2'
